//总体请求封装
import testRequest from "./testRequest";
import nativeUtil from "./JSBridge/NativeUtil";
import JsBridge from "./JSBridge/JsBridge";
import {
  IS_TEST,
  REQUEST_SUCCESS_CODE,
  REQUEST_FAILURE_MSG
} from "../config/config";
import router from "../router/index";

import { Dialog, Toast } from "vant";

const Request = {
  //发起请求
  sendRequest: (url, params, callback) => {
    // 使用静态数据的标志位
    if (nativeUtil.isDesktop() || IS_TEST) {
      return testRequest.test(url, params, callback);
    } else if (nativeUtil.isAndroid() || nativeUtil.isIOS()) {
      let json = {
        method: url,
        loading: false,
        params
      };

      //调用js桥接
      JsBridge.callHandler("request", JSON.stringify(json), params => {
        if (params) {
          try {
            let data = JSON.parse(params);
            if (data["code"] != REQUEST_SUCCESS_CODE) {
              if (data["message"]) {
                // Toast(data['message']);
                data["message"] = data["message"].replace(",", "<br/>");
                Dialog.alert({
                  title: "系统错误",
                  message: `<span style="font-size : 20px ;">${data["message"]}</span>`,
                  theme: "round-button"
                }).then(() => {
                  Dialog.close();
                });
              } else {
                Toast(REQUEST_FAILURE_MSG);
                // console.log(REQUEST_FAILURE_MSG)
              }
            }
            callback(data);
          } catch (e) {
            // Toast(REQUEST_FAILURE_MSG);
          }
        }
      });
    }
  },

  token(callback) {
    JsBridge.callHandler("getToken", null, token => {
      callback(token);
    });
  },

  logout() {
    JsBridge.callHandler("logout");
  },
  showLoading() {
    JsBridge.callHandler("showLoading");
  },
  closeLoading() {
    JsBridge.callHandler("closeLoading");
  },

  log(params) {
    JsBridge.callHandler("log", params);
  },

  //更换顶部状态栏颜色
  changeStatusBarStyle(color) {
    JsBridge.callHandler("changeStatusBarStyle", color);
  },

  //付款成功页面
  orderParkingId(oid) {
    JsBridge.callHandler("printReceipt", oid);
  },

  //  扫描二维码
  scanQRCode(orderParkingId, callback) {
    JsBridge.callHandler("scanQRCode", orderParkingId, decodeContent =>
      callback(decodeContent)
    );
  },

  goBack() {
    if (nativeUtil.isDesktop() || IS_TEST) {
      router.go(-1);
    } else {
      JsBridge.callHandler("goBack");
    }
  },

  scanPlateNumber(callback) {
    JsBridge.callHandler("scanPlateNumber", null, res => callback(res));
  },

  showPic(url) {
    JsBridge.callHandler("showImg", url);
  },

  closeScanQRCode() {
    JsBridge.callHandler("closeScanQRCode");
  },

  getStationId(callback) {
    JsBridge.callHandler("getStationId", null, res => {
      let data = JSON.parse(res);
      if (data["currentId"]) {
        callback(data["currentId"]);
      } else {
        callback(data["defaultId"]);
      }
    });
  },

  convertQRCode(content, size = 800, showLogo = true) {
    return new Promise(resolve => {
      //   console.log("拿到的地址 ===》》》", content);
      JsBridge.callHandler(
        "convertQRCode",
        { content, size, showLogo },
        res => {
          resolve(res);
        }
      );
    });
  },

  naviToOrderFlowList(orderParkingId) {
    JsBridge.callHandler("naviToOrderFlowList", orderParkingId);
  }
};

export default Request;
